<template>
  <span class="inline-badge" :style="'background-color: ' + this.bgColor">{{
    value
  }}</span>
</template>
<script>
export default {
  props: {
    bgColor: {
      default: "#4caf50"
    },
    value: {
      default: 0
    }
  }
};
</script>
<style>
span.inline-badge {
  display: inline-block;
  border-radius: 12px;
  padding: 5px 8px;
  text-transform: uppercase;
  font-size: 10px;
  color: #ffffff;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}
</style>
